import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminTiposDocumentoPage } from "@/features/admin-tipos-documento/components/AdminTiposDocumentoPage";
import { tiposDocumentoAdminQueryOptions } from "@/features/admin-tipos-documento/hooks/use-tipos-documento-admin";

/** Ruta `/admin/tipos-documento` · CRUD del catálogo de tipos de documento adicional (P31). */
export const Route = createFileRoute("/_authed-tw/admin/tipos-documento")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(tiposDocumentoAdminQueryOptions({ page: 1, pageSize: 15 })),
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminTiposDocumento]}>
      <AdminTiposDocumentoPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
